import React from 'react';
import AdminDataTable from './AdminDataTable';

/**
 * Configuration pour l'administration des mappings manuscript2article
 */
const manuscript2ArticleConfig = {
  entityName: 'manuscript2article',
  apiEndpoint: '/api/config/tool/manuscript2article',
  exportFileName: 'manuscript2article_mappings',
  
  translations: {
    title: 'MANUSCRIPT2ARTICLE_TITLE'
  },
  
  columns: [
    { key: 'id', label: 'ID', labelKey: 'TABLE_ID' },
    { key: 'manuscript_tag', label: 'Tag Manuscrit', labelKey: 'TABLE_MANUSCRIPT_TAG' },
    { key: 'ia_language', label: 'Langue IA', labelKey: 'TABLE_IA_LANGUAGE' },
    { key: 'cut_level', label: 'Niveau Coupe', labelKey: 'TABLE_CUT_LEVEL' },
    { key: 'header_text', label: 'Texte En-tête', labelKey: 'TABLE_HEADER_TEXT' },
    { 
      key: 'clean_content', 
      label: 'Nettoyer', 
      labelKey: 'TABLE_CLEAN_CONTENT',
      type: 'booleanTag'
    },
    { key: 'article_field', label: 'Champ Article', labelKey: 'TABLE_ARTICLE_FIELD' },
    { key: 'field_type', label: 'Type Champ', labelKey: 'TABLE_FIELD_TYPE' },
    { key: 'max_size', label: 'Taille Max', labelKey: 'TABLE_MAX_SIZE' },
    { 
      key: 'is_active', 
      label: 'Actif', 
      labelKey: 'TABLE_IS_ACTIVE',
      type: 'booleanTag'
    }
  ],
  
  formFields: [
    {
      name: 'manuscript_tag',
      label: 'Tag du manuscrit',
      labelKey: 'FORM_MANUSCRIPT_TAG',
      type: 'dynamic-select',
      dynamicSource: 'manuscript_tag',
      required: true
    },
    {
      name: 'ia_language',
      label: 'Langue IA',
      labelKey: 'FORM_IA_LANGUAGE',
      type: 'dynamic-select',
      dynamicSource: 'ia_language',
      required: true,
    },
    {
      name: 'cut_level',
      label: 'Niveau de coupe',
      labelKey: 'FORM_CUT_LEVEL',
      type: 'dynamic-select',
      dynamicSource: 'cut_level',
      required: true,
    },
    {
      name: 'header_text',
      label: 'Texte d\'en-tête',
      labelKey: 'FORM_HEADER_TEXT',
      type: 'text',
      required: false,
      placeholder: 'Texte affiché dans l\'interface...'
    },
    {
      name: 'clean_content',
      label: 'Nettoyer le contenu',
      labelKey: 'FORM_CLEAN_CONTENT',
      type: 'booleanTag'
    },
    {
      name: 'article_field',
      label: 'Champ d\'article de destination',
      labelKey: 'FORM_ARTICLE_FIELD',
      type: 'text',
      required: false,
      placeholder: 'motivation, physique, content...'
    },
    {
      name: 'field_type',
      label: 'Type de champ',
      labelKey: 'FORM_FIELD_TYPE',
      type: 'dynamic-select',
      dynamicSource: 'field_type',
      required: false
    },
    {
      name: 'max_size',
      label: 'Taille maximale',
      labelKey: 'FORM_MAX_SIZE',
      type: 'number',
      required: false,
      placeholder: '245, 500...'
    },
    {
      name: 'is_active',
      label: 'Actif',
      labelKey: 'FORM_IS_ACTIVE',
      type: 'booleanTag'
    }
  ],
  
  filters: [
    {
      name: 'manuscript_tag',
      label: 'Tag Manuscrit',
      labelKey: 'FILTER_MANUSCRIPT_TAG',
      type: 'text',
      placeholder: 'isCharacter, isMonster...'
    },
    {
      name: 'ia_language',
      label: 'Langue IA',
      labelKey: 'FILTER_IA_LANGUAGE',
      type: 'dynamic-select',
      dynamicSource: 'ia_language'
    },
    {
      name: 'header_text',
      label: 'Texte En-tête',
      labelKey: 'FILTER_HEADER_TEXT',
      type: 'text',
      placeholder: 'Personnalité, Apparence...'
    },
    {
      name: 'article_field',
      label: 'Champ Article',
      labelKey: 'FILTER_ARTICLE_FIELD',
      type: 'text',
      placeholder: 'motivation, content...'
    }
  ],
  
  defaultFormData: {
    manuscript_tag: '',
    ia_language: 'FR',
    cut_level: 2,
    header_text: '',
    clean_content: false,
    article_field: '',
    field_type: 'formated',
    max_size: null,
    is_active: true
  }
};

/**
 * Composant d'administration des mappings manuscript2article
 */
export default function AdminManuscript2ArticleTab() {
  return (
    <AdminDataTable {...manuscript2ArticleConfig} />
  );
}
